import { EventEmitter } from '@angular/core';
import { FieldViewModel } from '../../../models/field/field-layout-view-model.model';
import { BuiltInFieldId } from '../../../models/built-in-field-id.enum';

export class ColumnResizer {
  field: FieldViewModel;
  startX: number;
  startWidth: number;
  tableWidth = 0;
  columnResized = new EventEmitter<FieldViewModel>();

  onResizeColumnStart(event: any, field: FieldViewModel) {
    this.field = field;
    this.startX = event.pageX;
    this.startWidth = field.width;
  }

  mouseMove(event: MouseEvent) {
    if (!(this.field && event.buttons)) return;
    const total = event.pageX - this.startX;
    const soFar = this.field.width - this.startWidth;
    const delta = total - soFar;
    const newWidth = this.field.width + delta;

    if (newWidth >= 25) {
      this.field.width = newWidth;
      this.tableWidth += delta;
    }
  }

  mouseUp() {
    if (!this.field || this.field.fieldId === BuiltInFieldId.Score) {
      this.field = null;
      return;
    }

    this.columnResized.emit(this.field);
    this.field = null;
  }
}
